import config from '../config'
import { authHeader } from './auth-header'

export const smsService = {
  sendSms,
  getPendingFlightReminders,
  sendFlightReminders
}

function sendSms (number,from,message) {
  console.log(JSON.stringify({from:from,number: number, message: message}))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({from:from,number: number, message: message}),
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/customers/sendMessageToNumber`, requestOptions).then(handleResponse)
}

function getPendingFlightReminders () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/sms/pendingFlightReminders`, requestOptions).then(handleResponse)
}

function sendFlightReminders (invoiceIds, template) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify({ invoiceIds, template })
  }
  return fetch(`${config.apiUrl}/sms/sendFlightReminders`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout()
        // location.reload(true)
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data.Response
  })
}
